import { getAxiosClient } from "../../axios-client";
import { GetAllClientOrdersRequestBody, GetAllClientOrdersResponse } from "./types";

const axiosClient = getAxiosClient();
export const getAllClientOrders = async (body: GetAllClientOrdersRequestBody) => {
  return await axiosClient.ax.post<GetAllClientOrdersResponse>(
    "/Orders/GetLogged",
    body
  );
};
